import type { ColorLabel } from "common/constants/colorsOld";
import { assertUnreachable } from "common/utils/assertUnreachable";
import type { FeatureEnabledReason } from "lib/security/shared";

export function settingToDisplayValue(setting: boolean): string {
  switch (setting) {
    case true:
      return "Enabled";
    case false:
      return "Disabled";
    default:
      assertUnreachable(setting);
  }
}

export const featureFlagSettingOptions = [
  { label: "Enabled", value: "true" },
  { label: "Disabled", value: "false" },
  { label: "Default", value: undefined },
];

export function selectionToSetting(setting: string | number | boolean | undefined | null): boolean | undefined {
  if (setting === "true") {
    return true;
  } else if (setting === "false") {
    return false;
  }
  return undefined;
}

export function settingToSelection(setting: boolean | undefined, defaultValue?: string): string | undefined {
  if (setting === true) {
    return "true";
  } else if (setting === false) {
    return "false";
  }

  return defaultValue;
}

export function mapFeatureStatusToDisplayTextAndColor(statusText: string): {
  text: string;
  color: ColorLabel;
} {
  const mapping = {
    experimental: { text: "Experimental", color: "ruby" },
    alpha: { text: "Alpha", color: "citrine" },
    closed_beta: { text: "Closed Beta", color: "amber" },
    open_beta: { text: "Open Beta", color: "sapphire" },
    general_availability: { text: "GA", color: "emerald" },
    deprecated: { text: "Deprecated", color: "stone" },
  };

  return mapping[statusText] ?? { text: "Unknown", color: "stone" };
}

/**
 * If the feature is set on the per-env basis, it cannot be
 * overridden.
 */
export function isSetForEnvironment(reason: FeatureEnabledReason): boolean {
  return typeof reason.settings.environment === "boolean";
}
